module.exports = __webpack_public_path__ + "static/media/pic3.fe0ba038.jpg";